export async function saveToS3(organizationId, data: unknown, path: string) {
  await fetch('/save-yjs/' + path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Organization': organizationId,
    },
    body: JSON.stringify(data),
  });
}
